import packageJson from '../../package.json'

// Internal builds must not contact an external release feed by default.
const RELEASE_FEED_URL_VALUE = ''

const packageVersion = packageJson.version
if (typeof packageVersion !== 'string' || packageVersion.trim().length === 0) {
  throw new Error('Invalid package.json version')
}

export const APP_VERSION = packageVersion.trim()

export const RELEASE_FEED_URL = (process.env.NEXT_PUBLIC_RELEASE_FEED_URL ?? RELEASE_FEED_URL_VALUE).trim()
